import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permissions from 'api/Apollo/permissions';

import {
  mutation as updateSchemaLibraryMutation,
  buildVariables as buildUpdateSchemaLibraryVariables,
} from './update-schema-library-mutation-builder';

export default function useUpdateSchemaLibrary(options = {}) {
  const [trackWithUser] = useTrackWithUser('schema_library_updated');
  const [executeMutation, response] = useMutation(updateSchemaLibraryMutation, {
    ...options,
    context: { permission: permissions.updateSchemas },
    successMsg: 'Schema Library updated',
  });

  const updateSchemaLibrary = async ({ id, name, description }) => {
    const response = await executeMutation({
      variables: buildUpdateSchemaLibraryVariables({ id, name, description }),
    });

    if (!response.errors) {
      trackWithUser();
    }
  };

  return [updateSchemaLibrary, response];
}
